import { render, staticRenderFns } from "./unresolved-tracking-numbers.vue?vue&type=template&id=2aa4cf2c&"
import script from "./js/unresolved-tracking-numbers.js?vue&type=script&lang=js&"
export * from "./js/unresolved-tracking-numbers.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports